<template>
  <div class="mx-auto">
    <b-row class="mt-5">
      <div class="col-12">
        <h1>Terms And Conditions</h1>
      </div>
    </b-row>
    <div class="row">
      <div class="col-12 pb-5">
        <p>
          Welcome to our website. If you continue to browse and use this
          website, you are agreeing to comply with and be bound by the following
          terms and conditions of use, which together with our privacy policy
          and disclaimer govern propli.xyz relationship with you in relation
          to this website. If you disagree with any part of these terms and
          conditions, please do not use our website.
        </p>
        <p>
          The term propli.xyz or 'us' or 'we' refers to the owner of the
          website whose registered office is 11 magalies street Hurst Hill
          Johannesburg. The term 'you' refers to the user or viewer of our
          website.
        </p>
        <p>
          The use of this website is subject to the following terms of use: The
          content of the pages of this website is for your general information
          and use only. It is subject to change without notice. Neither we nor
          any third parties provide any warranty or guarantee as to the
          accuracy, timeliness, performance, completeness or suitability of the
          information and materials found or offered on this website for any
          particular purpose. You acknowledge that such information and
          materials may contain inaccuracies or errors and we expressly exclude
          liability for any such inaccuracies or errors to the fullest extent
          permitted by law. Your use of any information or materials on this
          website is entirely at your own risk, for which we shall not be
          liable. It shall be your own responsibility to ensure that any
          products, services or information available through this website meet
          your specific requirements. This website contains material which is
          owned by or licensed to us. This material includes, but is not limited
          to, the design, layout, look, appearance and graphics. Reproduction is
          prohibited other than in accordance with the copyright notice, which
          forms part of these terms and conditions. All trade marks reproduced
          in this website which are not the property of, or licensed to, the
          operator are acknowledged on the website. Unauthorised use of this
          website may give rise to a claim for damages and/or be a criminal
          offence. From time to time this website may also include links to
          other websites. These links are provided for your convenience to
          provide further information. They do not signify that we endorse the
          website(s). We have no responsibility for the content of the linked
          website(s). Your use of this website and any dispute arising out of
          such use of the website is subject to the laws of South Africa
        </p>
        <p>
          INTELLECTUAL PROPERTY: You agree that you will not upload or transmit
          any Content to propli.xyz that infringes any patent, trademark,
          trade secret, copyright or other proprietary rights ("Rights") of any
          party. You alone are responsible that you indeed have the right to
          submit Content to propli.xyz .
        </p>
        <p>Content Contributed to the Site by Members :</p>
        <p>
          The Site allows Members to post images and files. In this
          Agreement we refer to all of this Content provided by Users as “User
          Content”. In order for us to make the User Content you contribute
          available on the Site, and to operate, market and promote the Service,
          we need the right to make use of such User Content in accordance with
          and subject to this Agreement.
        </p>
        
        <p>
          propli.xyz reserves the right to remove Content from the Site at
          any time, without notice, for any reason, or for no reason, in its
          sole discretion.
        </p>
        <p>
          You represent and warrant to propli.xyz that (a) you are the sole
          owner, author and copyright owner of User Content you contribute to
          the Site or you have written permission from the author, owner or
          copyright owner to make such User Content available to the Service as
          “User Content”, and (b) such User Content does not infringe upon any
          third party rights (including but not limited to any copyright,
          patent, trademark, trade secret, other intellectual property rights,
          moral rights, privacy rights or publicity rights); (c) such User
          Content complies with this Agreement and does not contain any
          defamatory, libelous or obscene material; (d) such User Content does
          not violate any applicable laws, regulations, or contain any false
          statements or misrepresentations; and (e) you have the written
          consent, release, and/or permission of each and every identifiable
          individual person, or the owner/author of any objects or work in such
          User Content to use the name or likeness of each and every such
          identifiable individual person, object or work, to enable inclusion
          and use of such User Content in the manner contemplated by the Service
          and this Agreement.
        </p>
        <div id="c-div" class="space-100"></div>
        <h2 class="wow slideInUp">Copyright notice</h2>
        <div class="green-sep-sml wow jello"></div>
        <h4>1. Credit</h4>
        1.1 This document was created using a template from SEQ Legal
        (http://www.seqlegal.com). You must retain the above credit. Use of this
        document without the credit is an infringement of copyright. However,
        you can purchase from us an equivalent document that does not include
        the credit.
        <h4>2. Copyright notice</h4>
        2.1 Copyright (c) [2011-2021] [propli.xyz]. 2.2 Subject to the
        express provisions of this notice: (a) we, together with our licensors,
        own and control all the copyright and other intellectual property rights
        in our website and the material on our website; and (b) all the
        copyright and other intellectual property rights in our website and the
        material on our website are reserved.
        <h4>3. Copyright licence</h4>
        3.1 You may:<br />
        (a) view pages from our website in a web browser;<br />
        (b) download pages from our website for caching in a web browser;<br />
        (c) print pages from our website ;<br />
        (d) [stream audio and video files from our website]; and<br />
        (e) [use [our website services] by means of a web browser],<br />
        subject to the other provisions of this notice.<br />
        3.2 Except as expressly permitted by the other provisions of this
        notice, you must not download any material from our website or save any
        such material to your computer.<br />
        3.3 You may only use our website for your own personal purposes, and you
        must not use our website for any other purposes.<br />
        3.4 Except as expressly permitted by this notice, you must not edit or
        otherwise modify any material on our website.<br />
        3.5 Unless you own or control the relevant rights in the material, you
        must not:<br />
        (a) republish material from our website (including republication on
        another website);<br />
        (b) sell, rent or sub-license material from our website;<br />
        (c) show any material from our website in public;<br />
        (d) exploit material from our website for a commercial purpose; or<br />
        (e) redistribute material from our website, save to the extent expressly
        permitted by this notice.<br />
        3.6 You are not allowed to embed this website in an App or iframe
        without permission.<br />
        <h4>4. Acceptable use</h4>
        4.1 You must not:<br />
        (a) use our website in any way or take any action that causes, or may
        cause, damage to the website or impairment of the performance,
        availability or accessibility of the website;<br />
        (b) use our website in any way that is unlawful, illegal, fraudulent or
        harmful, or in connection with any unlawful, illegal, fraudulent or
        harmful purpose or activity;<br />
        (c) use our website to copy, store, host, transmit, send, use, publish
        or distribute any material which consists of <br />(or is linked to) any
        spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit
        or other malicious computer software; or<br />
        (d) conduct any systematic or automated data collection activities
        (including without limitation scraping, data mining, data extraction and
        data harvesting) on or in relation to our website without our express
        written consent.<br />
        <h4>5. Report abuse</h4>
        5.1 If you learn of any unlawful material or activity on our website, or
        any material or activity that breaches this notice, please let us
        know.<br />
        5.2 You can let us know about any such material or activity [by email or
        using our abuse reporting form].<br />
        <h4>6. Enforcement of copyright</h4>
        6.1 We take the protection of our copyright very seriously.<br />
        6.2 If we discover that you have used our copyright materials in
        contravention of the licence set out in this notice, we may bring legal
        proceedings against you, seeking monetary damages and/or an injunction
        to stop you using those materials. You could also be ordered to pay
        legal costs.<br />
        <h4>7. Permissions</h4>
        7.1 You may request permission to use the copyright materials on our
        website by [writing to us by email or post, using the contact details
        published on the website].<br />
     
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
